<template src="./template.html"></template>
<style lang="css" scoped>
  .t.no-before {padding-left: 0 !important;}
  .t.no-before:before {display: none !important;}
</style>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  import Datepicker from 'vuejs-datepicker'
  import { en, de } from 'vuejs-datepicker/dist/locale'

  const date = new Date()
  const from = toTime(new Date(date.setDate(date.getDate() + 1)), '00:00:00')

  function toTime(date, timeString) {
    const timeFragments = timeString.split(':')
    date.setHours(timeFragments[0])
    date.setMinutes(timeFragments[1])
    date.setSeconds(timeFragments[2])
    return date
  }

  export default {
    name: 'Shipping',
    components: {
      Datepicker,
    },
    props: {
      index: Number,
      isTabActive: Boolean,
      showShipping: Boolean,
    },
    data() {
      return {
        languages: {
          en: en,
          de: de,
        },
        toMonth: 2,
        to: null,
      }
    },
    computed: {
      ...mapState('shipping', [
        'shippingServices',
        'activeShippingService',
        'deliveryDate',
        'deliveryDateConfig',
      ]),
      ...mapState('deliveryAddress', [
        'deliveryAddress',
        'deliveryAddressActive',
      ]),
      ...mapState('invoiceAddress', ['invoiceAddress']),
      ...mapGetters('shipping', [ 'isPending' ]),
      ...mapState('settings', [
        'settings',
        'pendingSettings',
      ]),
      ...mapState('summary', [ 'coinPacksOnly' ]),
      isVirtualCurrency() {
        return !this.pendingSettings &&
               this.settings.active_features &&
               this.settings.active_features.use_virtual_currency &&
               !this.coinPacksOnly
      },
      customer() {
        return process.env.customer
      },
      disabledDates() {
        const that = this

        return {
          customPredictor: function(myDate) {
            return !that.validDate(myDate)
          },
        }
      },
      openDate() {
        const date = new Date()
        const firstDay = new Date().setHours(0, 0, 0, 0)
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).setHours(23, 59, 59, 999)
        const msPerDay = 60 * 60 * 24 * 1000
        const dayCount = (
                           lastDay - firstDay
                         ) / msPerDay
        let valid = false
        for (let x = 0; x <= dayCount; x++) {
          const checkDate = new Date(firstDay + (
            x * msPerDay
          ))
          valid = this.validDate(checkDate)

          if (valid) {
            x = dayCount + 1
          }
        }
        return new Date(valid ? firstDay : lastDay + 1)
      },
    },
    watch: {
      deliveryDateConfig(val) {
        this.toMonth = this.deliveryDateConfig.deliveryDateTimeFrame || 2
        const date = new Date()
        this.to = toTime(new Date(date.setMonth(date.getMonth() + this.toMonth)), '23:59:59')
      },
      activeShippingService(val, oldVal) {
        if (val && oldVal !== val) {
          this.getDeliveryDateConfig(val).then(_ => {
            if (!this.validDate(new Date(this.deliveryDate))) {
              this.updateDeliveryDate(null)
            }
          })
        }
      },
    },
    created() {
      this.getShippingServices().then(_ => {
        if (this.shippingServices && this.shippingServices.length === 1) {
          this.updateShippingService(this.shippingServices[0].name)
        }
      })
      this.$store.subscribe(mutation => {
        switch (mutation.type) {
          case 'summary/LAST_REMOVE_PRODUCT':
            this.getShippingServices().then(_ => {
              if (this.shippingServices && this.shippingServices.length === 1) {
                this.updateShippingService(this.shippingServices[0].name)
              }
            })
            break
          default:
            return false
        }
      })
    },
    methods: {
      ...mapActions('shipping', [
        'getShippingServices',
        'getDeliveryDateConfig',
        'updateDeliveryDate',
        'updateShippingService',
      ]),
      validDate(myDate) {
        if (!myDate || !myDate.setHours) {
          return true
        } else if (myDate < from || myDate > this.to) {
          return false
        }
        const address =
          this.deliveryAddress && this.deliveryAddressActive ? this.deliveryAddress : this.invoiceAddress
        const country = address.country.toLowerCase() || 'bogus-country-without-limitations'
        const weekday = myDate.getDay()
        const config = this.deliveryDateConfig
        const exceptions = (config.deliveryDateExceptions && config.deliveryDateExceptions[country] || []).map(i => new Date(i).toDateString())
        const dateValues = (config.noDeliveryDates && config.noDeliveryDates[country] || []).map(i=>(new Date(i)).toDateString())
        return !(
          ((config.noDeliveryDays && config.noDeliveryDays[country] || []).includes(weekday) && !exceptions.includes(myDate.toDateString())) ||
          dateValues.includes(myDate.toDateString())
        )
      },
    },
  }
</script>
